<template>
  <div class="collapse-item" :class="{active: show, 'not-collapse': disabled}">
    <div class="collapse-item-cover" @click="change"><span>{{title}}</span></div>
    <div class="collapse-item-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CollapseItem',
  // props: ['title'],
  props: {
    title: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    change() {
      if(this.disabled) return
      this.$parent.cut(this._uid)
      this.show = true;
    }
  },
  created() {

  }
}
</script>

<style lang="scss" scoped>
.collapse-item {
  display: flex;
  flex-grow: 1;
  height: 100%;

  .collapse-item-cover {
    flex: 1;
    height: 100%;
    position: relative;
    cursor: pointer;

    span {
      font-size: 20px;
      position: absolute;
      width: 1em;
      bottom: 10px;
      left: 50%;
      margin-left: -0.5em;
      line-height: 1em;
      color: #999999;
    }
  }

  .collapse-item-content {
    width: 0;
    transition: all 0.2s ease-in-out;
    overflow: hidden;
  }

  &.active:not(.not-collapse) {
    .collapse-item-content {
      width: 37.5vw;
      max-width: 720px;
    }
  }

  &.not-collapse {
    background: #f3f3f3;
  }

}

.collapse-item.bvi-1 .collapse-item-cover {
  background: url("~@/assets/images/bvi_1.png") center / cover no-repeat;
}

.collapse-item.bvi-2 .collapse-item-cover {
  background: url("~@/assets/images/bvi_2.png") center / cover no-repeat;
}

.collapse-item.bvi-3 .collapse-item-cover {
  background: url("~@/assets/images/bvi_3.png") center / cover no-repeat;
}

.collapse-item.bvi-4 .collapse-item-cover {
  background: url("~@/assets/images/bvi_4.png") center / cover no-repeat;
}

</style>
